import React from 'react';
import classnames from 'classnames';

export default function TextArea({ sm, md, lg, className, ...args }) {
  return (
    <textarea
      className={classnames(
        'form-control',
        className,
        sm && 'form-control-sm',
        md && 'form-control-md',
        lg && 'form-control-lg',
      )}
      {...args}
    />
  );
}
